import React, {useState} from 'react';
import {accountService} from "./admin/Account.service";
import {Col, Container, Form, Row} from "react-bootstrap";
const Logme = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isPending, setIsPending] = useState(false);


    const Loggin = (e) => {
        e.preventDefault();
        const userdatas = {username, password};
        setIsPending(true);
            fetch(process.env.REACT_APP_API_URLSF+'/api/users/form/stats', {
                method: 'POST',
                headers: {"Content-type": "application/json",
                },
                body: JSON.stringify(userdatas),
            }).then((response)=>
                response.json()
            ).catch(error => console.log(error))

        //NVDXAVIER
        //const config = {contentType: "application/json" };
        //const dataEncodedtoJson = JSON.stringify(userdatas);
        // axios.post(`https://api.nvdxavier.com`+`/api/login_check`, dataEncodedtoJson, config)
        //     .then((response) =>  response.data.json)
        //     .then((userdatas) => {
        //         accountService.saveToken(JSON.stringify(userdatas));
        //         setIsPending(false);
        //         window.location.replace(process.env.REACT_APP_MYAPP);
        //     })
        //     .catch(error => console.log(error))

            fetch(process.env.REACT_APP_API_URLSF+`/api/login_check`, {
            method: 'POST',
            headers: {"Content-type": "application/json",
            },
            body: JSON.stringify(userdatas),
        })
            .then((response) =>  response.json())
            .then((userdatas) => {
                accountService.saveToken(JSON.stringify(userdatas));
                setIsPending(false);
                window.location.replace(process.env.REACT_APP_MYAPP);
            })
            .catch(error => console.log(error))
    }
        return (
            <React.Fragment>
                <section id="signup" className="signup-section">
                    <Container>
                        <Row>
                            <Col></Col>
                            <Col>
                                <Form onSubmit={Loggin}>
                                <Form.Group>
                                    <Form.Label>Log me plenty!!</Form.Label>
                                    <Form.Control type="text"
                                                  className="form-control mb-2"
                                                  id="exampleInputUSername"
                                                  aria-describedby="usernamelHelp"
                                                  placeholder="Enter username"
                                                  required={true}
                                                  value={username}
                                                  onChange={(e) => setUsername(e.target.value)}
                                    />

                                    <Form.Control type="password"
                                                  className="form-control mb-2"
                                                  id="exampleInputPassword1"
                                                  name="password"
                                                  placeholder="Password"
                                                  required
                                                  value={password}
                                                  autoComplete="current-password"
                                                  onChange={(e) => setPassword(e.target.value)}/>

                                    {!isPending && <button className="btn btn-secondary btn-outline-light btn-sm">Submit</button>}
                                    {isPending && <button className="btn btn-secondary btn-outline-light btn-sm">Submit.....</button>}
                                </Form.Group>
                            </Form>
                            </Col>
                            <Col></Col>
                        </Row>
                    </Container>
                </section>
            < /React.Fragment>
        );
}
export default Logme;
